import { render, staticRenderFns } from "./SoftwareComponentConfDiff.vue?vue&type=template&id=048e6b10&"
import script from "./SoftwareComponentConfDiff.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentConfDiff.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentConfDiff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports